module.exports = __webpack_public_path__ + "5e7bf0b3b40a4df1781357931ea00ed8.svg";